module.exports = __webpack_public_path__ + "static/img/-s-modification_ice cream@3x.6a9bec1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/-s-modification_ice cream@3x.png
// module id = szDp
// module chunks = 1